module.exports = __webpack_public_path__ + "static/media/Icon_Case_Studies_Grey70.a31422cc.png";